// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountVoicemailOptInModel {
    static getAttributeTypeMap() {
        return AccountVoicemailOptInModel.attributeTypeMap;
    }
}
AccountVoicemailOptInModel.discriminator = undefined;
AccountVoicemailOptInModel.attributeTypeMap = [
    {
        "name": "phoneNumberId",
        "baseName": "phoneNumberId",
        "type": "number"
    },
    {
        "name": "isVmOptedIn",
        "baseName": "isVmOptedIn",
        "type": "boolean"
    }
];
//# sourceMappingURL=accountVoicemailOptInModel.js.map